var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import Switch from "react-router/Switch";
import Route from "react-router/Route";
import Redirect from "react-router/Redirect";
import generatePath from "react-router/generatePath";

var EMPTY = {};
var DEFAULT_ROUTE_PROP = 'route';
var DEFAULT_RENDER_CHILD_PROP = 'renderChild';
var DEFAULT_MATCH_PROP = 'match';
var DEFAULT_ADD_PARAM_PROPS = false;

var renderRoutes = function renderRoutes(routes) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$extraProps = _ref.extraProps,
      extraProps = _ref$extraProps === undefined ? EMPTY : _ref$extraProps,
      _ref$switchProps = _ref.switchProps,
      switchProps = _ref$switchProps === undefined ? EMPTY : _ref$switchProps,
      _ref$routeProp = _ref.routeProp,
      routeProp = _ref$routeProp === undefined ? DEFAULT_ROUTE_PROP : _ref$routeProp,
      _ref$matchProp = _ref.matchProp,
      matchProp = _ref$matchProp === undefined ? DEFAULT_MATCH_PROP : _ref$matchProp,
      _ref$renderChildProp = _ref.renderChildProp,
      renderChildProp = _ref$renderChildProp === undefined ? DEFAULT_RENDER_CHILD_PROP : _ref$renderChildProp,
      _ref$addParamProps = _ref.addParamProps,
      addParamProps = _ref$addParamProps === undefined ? DEFAULT_ADD_PARAM_PROPS : _ref$addParamProps,
      _ref$noRenderChildCom = _ref.noRenderChildComponent,
      noRenderChildComponent = _ref$noRenderChildCom === undefined ? function () {
    return false;
  } : _ref$noRenderChildCom,
      _ref$overrideRenderRo = _ref.overrideRenderRoutes,
      overrideRenderRoutes = _ref$overrideRenderRo === undefined ? false : _ref$overrideRenderRo;

  if (!routes) {
    return null;
  }

  var renderChild = function renderChild(route) {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var stripRouteProp = _ref2[routeProp],
          stripMatchProp = _ref2[matchProp],
          otherProps = _objectWithoutProperties(_ref2, [routeProp, matchProp]);

      return route.routes ? (overrideRenderRoutes ? overrideRenderRoutes : renderRoutes).call(null, route.routes, {
        extraProps: otherProps,
        switchProps: switchProps,
        routeProp: routeProp,
        matchProp: matchProp,
        renderChildProp: renderChildProp,
        addParamProps: addParamProps,
        noRenderChildComponent: noRenderChildComponent,
        overrideRenderRoutes: overrideRenderRoutes
      }) : noRenderChildComponent;
    };
  };

  var mergeRouteProps = function mergeRouteProps(route, props) {
    var _ref3, _ref4, _ref5;

    var stirpRoute = props.route,
        match = props.match,
        otherProps = _objectWithoutProperties(props, ["route", "match"]);

    return _extends({}, route.props ? route.props : EMPTY, otherProps, extraProps, route.forcedProps ? route.forcedProps : EMPTY, routeProp ? (_ref3 = {}, _ref3[routeProp] = route, _ref3) : EMPTY, matchProp ? (_ref4 = {}, _ref4[matchProp] = match, _ref4) : EMPTY, addParamProps ? match ? match.params ? match.params : EMPTY : EMPTY : EMPTY, renderChildProp ? (_ref5 = {}, _ref5[renderChildProp] = renderChild(route), _ref5) : EMPTY);
  };

  return React.createElement(
    Switch,
    switchProps,
    routes.map(function (route, i) {
      return React.createElement(Route, {
        key: route.key || i,
        path: route.path,
        exact: route.exact,
        strict: route.strict,
        render: function render(props) {
          return route.redirect !== void 0 ? React.createElement(Redirect, {
            from: route.path,
            to: generatePath(route.redirect, props.match.params)
          }) : route.component ? React.createElement(route.component, mergeRouteProps(route, props)) : renderChild(route)(mergeRouteProps(route, props));
        }
      });
    })
  );
};

export default renderRoutes;